var _path, _path2, _path3, _path4;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgGoogleSignin(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 28,
    height: 28,
    viewBox: "0 0 28 28",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M24.0003 14.2301C24.0003 13.5504 23.944 12.867 23.8241 12.1982H14.2017V16.0489H19.712C19.4833 17.2908 18.7486 18.3895 17.6728 19.0876V21.5861H20.9602C22.8907 19.8445 24.0003 17.2725 24.0003 14.2301Z",
    fill: "#4285F4"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M14.2013 23.9995C16.9527 23.9995 19.273 23.114 20.9636 21.5855L17.6762 19.087C16.7615 19.6969 15.5808 20.0423 14.2051 20.0423C11.5436 20.0423 9.28703 18.2823 8.47735 15.916H5.08496V18.4917C6.81677 21.8684 10.3441 23.9995 14.2013 23.9995Z",
    fill: "#34A853"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M8.47383 15.9161C8.0465 14.6741 8.0465 13.3293 8.47383 12.0874V9.51172H5.08519C3.63827 12.3373 3.63827 15.6662 5.08519 18.4917L8.47383 15.9161Z",
    fill: "#FBBC04"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M14.2013 7.95791C15.6557 7.93587 17.0614 8.47232 18.1147 9.45703L21.0273 6.60209C19.1831 4.90456 16.7353 3.97128 14.2013 4.00067C10.3441 4.00067 6.81677 6.13178 5.08496 9.51215L8.4736 12.0878C9.27953 9.71791 11.5399 7.95791 14.2013 7.95791Z",
    fill: "#EA4335"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgGoogleSignin);
export default __webpack_public_path__ + "static/media/GoogleSignin.97cf060e573e1b90eb619efdab8b193d.svg";
export { ForwardRef as ReactComponent };